module.exports = __webpack_public_path__ + "img/detail-banner.08e575eb.png";